export const types = {
    MESSAGE: 'MESSAGE',
};